<template>
  <KenshinRequestDetail v-if="isRender" :data="corpRequestDetailData"/>
</template>

<script>
import KenshinRequestDetail from "@/components/mock/common/KenshinRequestDetail";
export default {
  data() {
    return {
      isRender: false,
      corpRequestDetailData: {}
    };
  },
  props: {
    requestDetailData: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  components: { KenshinRequestDetail },
  methods: {
    findCorpDetail() {
      let api = this.getCorpRequestDetail;
      let success = this.getCorpRequestDetailSuccess;
      let error = this.getCorpRequestDetailError;
      this.apiCall(api, success, error);
    },
    getCorpRequestDetail(client){
      let receptionNumber = this.requestDetailData.receptionNumber.split("-")[0];
      return client.apis.internalKenshin.getKenshinExaminationReceptionDetailPOST({
        body: { receiptNumber: receptionNumber }
      });
    },
    getCorpRequestDetailSuccess(result) {
      this.corpRequestDetailData = result.obj.applicationDetails;
      this.isRender = true;
    },
    getCorpRequestDetailError(error) {
      // this.showErrorMessage(error);
    },
  },
  created() {
    this.findCorpDetail();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/mock/philips/call/components/KenshinRequestDetailCard.vue